import { css } from '@emotion/react'
import { Cell, Flow, FormControl, Grid, Theme, useTheme } from 'bold-ui'
import { CnsField, DateField, TextField } from 'components/form'

import { MamografiaPerguntaField } from './model-mamografia'

export function MamografiaDadosExameModalStep() {
  const theme = useTheme()
  const styles = createStyles(theme)

  return (
    <Flow direction='vertical'>
      <Grid>
        <Cell>
          <DateField name={MamografiaPerguntaField.dataSolicitacao} label='Data da solicitação' required />
        </Cell>
        <Cell size={10}>
          <Flow direction='vertical' justifyItems='stretch' style={styles.container}>
            <FormControl label='Responsável' style={styles.title} required />
            <TextField name={MamografiaPerguntaField.nomeResponsavel} label='Nome' required />
            <CnsField name={MamografiaPerguntaField.cns} label='CNS' required clearable />
          </Flow>
        </Cell>
        <Cell size={10}>
          <Flow direction='vertical' justifyItems='stretch' style={styles.container}>
            <FormControl label='Conselho' style={styles.title} required />
            <TextField name={MamografiaPerguntaField.siglaNomeConselho} label='Nome' required clearable />
            <TextField name={MamografiaPerguntaField.numeroConselho} label='Número' required clearable />
          </Flow>
        </Cell>
      </Grid>
    </Flow>
  )
}

const createStyles = (theme: Theme) => ({
  container: css`
    position: relative;
    margin-top: 1rem;
    padding: 1rem;
    border: 1px solid ${theme.pallete.gray.c80};
  `,
  title: css`
    font-weight: bold;
    position: absolute;
    top: -0.75rem;
    margin-left: -0.75rem;
    padding: 0 0.5rem;
    background-color: ${theme.pallete.surface.main};
  `,
})
